import { atom, useAtom, useSetAtom } from "jotai";

const formuleMergeAtom = atom(false);
const useIsLiveMerge = () => {
  const atom = useAtom(formuleMergeAtom);
  return atom;
};

export const useSetLiveMerge = () => useSetAtom(formuleMergeAtom);

export default useIsLiveMerge;
